/**
 * TrustGates — composes the two privacy / safety prompts the brief
 * asks for into a single root-level mount:
 *   1. <ConsentManager />  — Granular Data Trust Center (everyone)
 *   2. <AgeGateModal />    — Verifiable Parental Consent (authed users)
 *
 * Each component is internally idempotent (won't re-show if the user
 * has already responded), so this gate is safe to mount once at app
 * level next to <DailyLimitGate />.
 */
import { useAuth } from "@/context/AuthContext";
import ConsentManager from "@/components/ConsentManager";
import AgeGateModal from "@/components/AgeGateModal";

export default function TrustGates() {
  const { user } = useAuth();
  return (
    <>
      <ConsentManager />
      {user && <AgeGateModal user={user} />}
    </>
  );
}
